import {requests} from "../../utils/helpers/api.services";
import {DASHBOARD_URL} from "../../utils/helpers/api.routes";
import {IDashboard} from './dto/IDashboard';

export const DashboardService = {
    getDashboard:(params: any): Promise<IDashboard> => requests.get(DASHBOARD_URL, params)
}